import { Maximize2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

interface ExamExhibitProps {
  alt: string;
  caption: string;
  expandLabel: string;
  imageUrl: string;
  title: string;
}

export function ExamExhibit({
  alt,
  caption,
  expandLabel,
  imageUrl,
  title,
}: ExamExhibitProps) {
  return (
    <Dialog>
      <figure className="flex w-full flex-col gap-2.5 overflow-hidden rounded-[20px] border border-[#dddfe4] bg-[#f4f4f6] px-4 pb-3.5 pt-4">
        <div className="flex h-40 w-full items-center justify-center overflow-hidden rounded-[14px] border border-[#dddfe4] bg-white">
          <img alt={alt} className="h-full w-full object-contain" src={imageUrl} />
        </div>
        <figcaption className="flex w-full items-center gap-2">
          <span className="min-w-0 flex-1 text-xs font-medium leading-[18px] tracking-[0.2px] text-[#5b616d]">
            {caption}
          </span>
          <DialogTrigger asChild>
            <button
              className="flex shrink-0 items-center gap-1.5 rounded-full border border-[#dddfe4] bg-white py-1.5 pl-2.5 pr-3 text-xs font-semibold leading-[18px] tracking-[0.2px] text-[var(--dp-brand-button)]"
              type="button"
            >
              <Maximize2 aria-hidden="true" className="h-4 w-4" />
              {expandLabel}
            </button>
          </DialogTrigger>
        </figcaption>
      </figure>
      <DialogContent className="h-[min(480px,calc(100dvh-32px))] w-[min(712px,calc(100vw-32px))] max-w-none overflow-hidden border border-[#dddfe4] bg-white p-0 shadow-none [display:flex] sm:rounded-[14px] [&>button]:right-3 [&>button]:top-3 [&>button]:flex [&>button]:h-10 [&>button]:w-10 [&>button]:items-center [&>button]:justify-center [&>button]:rounded-xl [&>button]:bg-black/55 [&>button]:text-white [&>button]:opacity-100 [&>button]:ring-offset-0 [&>button]:hover:bg-black/70 [&>button_svg]:h-5 [&>button_svg]:w-5">
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <div className="h-full w-full overflow-hidden rounded-[14px]">
          <img alt={alt} className="h-full w-full object-contain" src={imageUrl} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
